import { X } from '@ui/components/icons';
import { Portal } from '@ui/lib/park/portal';
import { Dialog } from '@ui/lib/park/ui/dialog';
import { Icon } from '@ui/lib/park/ui/icon';
import { ReactNode } from 'react';
import { Flex } from 'styled-system/jsx';

import { MassiveTokenSearch } from './components/MassiveTokenSelectTable/MassiveTokenSearch';
import { MassiveTokenSelectTable } from './components/MassiveTokenSelectTable/MassiveTokenSelectTable';
import { MassiveTokenTabs } from './components/MassiveTokenSelectTable/MassiveTokenTabs';

export const MassTokenSelectModal = ({ children }: { children: ReactNode }) => {
  return (
    <Dialog.Root lazyMount unmountOnExit modal>
      <Dialog.Trigger asChild>{children}</Dialog.Trigger>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content
            display="flex"
            flexDir="column"
            my={{
              base: 0,
              desktop: 8,
            }}
          >
            <Dialog.Title asChild>
              <>
                <Flex
                  p={4}
                  bg="black.lightBlack"
                  justifyContent="space-between"
                  gap="20px"
                  alignItems="center"
                >
                  <MassiveTokenSearch flex={1} />
                  <Dialog.CloseTrigger>
                    <Icon boxSize="6">
                      <X />
                    </Icon>
                  </Dialog.CloseTrigger>
                </Flex>
                <MassiveTokenTabs />
              </>
            </Dialog.Title>

            <Dialog.Description
              bg="black.lv1"
              gap={6}
              pb={5}
              borderBottomRadius="8px"
              display="flex"
              flexDir="column"
              minW={{
                base: '100%',
                tablet: '450px',
              }}
              overflowY="auto"
              position="relative"
              flex={1}
              h="full"
            >
              <Dialog.Context>
                {(api) => (
                  <MassiveTokenSelectTable
                    onItemClickCallBack={() => api.setOpen(false)}
                  />
                )}
              </Dialog.Context>
            </Dialog.Description>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
